module.exports = __webpack_public_path__ + "img/bg-title3.e9db70d2.png";